import { Text } from '@savvy-kit/foundations/text';
import { cn } from '@savvy-kit/lib/utils';
import { TooltipWrapper } from 'src/components/performance-report/performance-returns-details';

import { useIsSmallScreen } from '@savvy/deprecated-shared/hooks/use-is-small-screen';

export default function PortfolioAccountItemDescriptionRow({
  icon,
  title,
  subtitle,
  customNote,
}: {
  readonly icon: React.ReactElement;
  readonly title: string | null | undefined;
  readonly subtitle: string | null;
  readonly customNote: string | null;
}) {
  const isSmallScreen = useIsSmallScreen();
  const renderTitle = () => {
    return (
      <Text variant={isSmallScreen ? 'body-sm' : 'body'} color="dark" className="font-bold">
        {title}
      </Text>
    );
  };

  return (
    <div className="flex items-center">
      <div className={cn('flex flex-row items-end', isSmallScreen ? 'pr-2' : 'pr-4')}>{icon}</div>
      <div className="flex flex-col gap-0">
        {customNote !== null ? (
          <TooltipWrapper title={customNote} placement="bottom">
            {renderTitle()}
          </TooltipWrapper>
        ) : (
          <>{renderTitle()}</>
        )}
        <Text color="secondary" variant={isSmallScreen ? 'caption' : 'body-sm'}>
          {subtitle}
        </Text>
      </div>
    </div>
  );
}
